import { useEffect, useState } from 'react'
import { useSaveSystemMessage } from '../../../../fetchData/mutations/systemMessage/useSaveSystemMessage'
import { useSystemMessage } from '../../../../fetchData/queries/settings/useSystemMessage'
import { useDeleteSystemMessage } from '../../../../fetchData/mutations/systemMessage/useDeleteSystemMessage'
import styles from '../AdminTools.module.css'
import { SystemMessageDetails } from '../../../../interfaces/systemSettings/SystemMessageDetails'
import { HeaderAlignedTaBortButton } from './AdminInputs/HeaderAlignedTaBortButton'
import { SparaButton } from './AdminInputs/SparaButton'
import { HeaderAlignedMessageType } from './AdminInputs/HeaderAlignedMessageType'
import { HeaderAlignedDuration } from './AdminInputs/HeaderAlignedDuration'
import { HeaderAlignedMessageText } from './AdminInputs/HeaderAlignedMessageText'

export const SystemMessage = () => {
  const systemMessage = useSystemMessage().data
  const saveSystemMessage = useSaveSystemMessage()
  const deleteSystemMessage = useDeleteSystemMessage()

  const [type, setType] = useState<number>(0)
  const [durationInMinutes, setDurationInMinutes] = useState<number>(0)
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    if (deleteSystemMessage.data?.success) {
      setType(0)
      setDurationInMinutes(0)
      setMessage('')
    }
  }, [deleteSystemMessage.data?.success])

  const isFormDisabled = typeof systemMessage?.message === 'string'

  const handleSave = () => {
    const saveMessage: SystemMessageDetails = {
      message: message,
      type: type,
      durationInMinutes: durationInMinutes,
    }

    saveSystemMessage.mutate(saveMessage)
  }

  const handleDelete = () => {
    deleteSystemMessage.mutate()
  }

  const saveDisabled = message?.length === 0 || !(durationInMinutes >= 1)

  const usageInstruction = isFormDisabled
    ? 'Ta bort meddelandet för att lägga till ett nytt'
    : 'Här kan du ange ett meddelande som visas för användare'

  return (
    <div className={styles.formContainer}>
      <h6 className={styles.inputGroupHeader}>Systemmeddelande</h6>
      <p className={styles.usageInstruction}>{usageInstruction}</p>

      <HeaderAlignedMessageType
        value={systemMessage?.type ?? type}
        onChange={setType}
        disabled={isFormDisabled}
      />

      <HeaderAlignedDuration
        value={systemMessage?.durationInMinutes ?? durationInMinutes}
        onChange={setDurationInMinutes}
        disabled={isFormDisabled}
      />

      <HeaderAlignedMessageText
        value={systemMessage?.message ?? message}
        onChange={setMessage}
        disabled={isFormDisabled}
      />

      {isFormDisabled ? (
        <HeaderAlignedTaBortButton
          handleClick={handleDelete}
          buttonText="Radera"
        />
      ) : (
        <SparaButton handleClick={handleSave} disabled={saveDisabled} />
      )}
    </div>
  )
}
